import { render, staticRenderFns } from "./Navbar.vue?vue&type=template&id=48170d9a"
var script = {}
import style0 from "./Navbar.vue?vue&type=style&index=0&id=48170d9a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports